module.exports = __webpack_public_path__ + "static/media/Nest-Hero.7d50e87f.jpg";